import { useQuery } from "@tanstack/react-query";
import { SITE_DESIGNS_FOLDERS } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";
import { queryClient } from "../../utils/QueryUtils";

/** @typedef {import("@/types/data/UserSite.mjs").SiteDesignsFolder} SiteDesignsFolder */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  // staleTime: Infinity,
  retry: false,
};

/**
 * The user's site-designs folders.
 * @param {QueryHookOptions<SiteDesignsFolder[]>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ folders: SiteDesignsFolder[] } & QueryResultRest<SiteDesignsFolder[]>}
 */
const useSiteDesignsFolders = (options = {}) => {
  const { data, ...rest } = useQuery({
    queryKey: [SITE_DESIGNS_FOLDERS],
    queryFn: () =>
      /** @type {Promise<SiteDesignsFolder[]>} */ (UserService.getSiteDesignsFolders()),
    ...defaults,
    ...options,
  });

  const folders = data ?? [];

  return {
    folders,
    ...rest,
  };
};

export const invalidateSiteDesignsFolders = () => {
  queryClient.invalidateQueries([SITE_DESIGNS_FOLDERS]);
};

export default useSiteDesignsFolders;
